import React from 'react'
import BajasTable from './components/BajasTable'

export default function index() {
    return (
        <div className="mt-1 flex flex-col items-start">

            <BajasTable />
        </div>
    )
}
